export default __webpack_public_path__ + "static/media/ENGLISH_READING.3c1b0754.svg";